import styled from 'styled-components'

interface HeadingProps {
  capitalize?: boolean
}

const BaseHeading = styled.h1<HeadingProps>`
  font-family: ${({ theme }) => `${theme.global.fontNames.serif}`};
  font-size: 7.4rem;
  line-height: 8rem;
  font-weight: 600;
  ${({ capitalize }) => capitalize && 'text-transform: capitalize;'};
  letter-spacing: -0.02em;
  font-feature-settings: 'pnum' on, 'lnum' on, 'liga' 1;
  color: ${({ theme }) => `${theme.global.colors.elemyGreen}`};

  @media ${({ theme }) => theme.device.tablet} {
    font-size: 4.6rem;
    line-height: 5.2rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    font-size: 3.8rem;
    line-height: 4.8rem;
  }
`

export const H1 = BaseHeading

export const H2 = styled(BaseHeading).attrs<typeof BaseHeading>(({ as }) => ({ as: as || 'h2' }))`
  font-size: 4.8rem;
  line-height: 6.4rem;
  font-weight: ${({ theme }) => theme.global.font.weight.normal};
  letter-spacing: 0;
  font-feature-settings: 'pnum' on, 'lnum' on;

  @media ${({ theme }) => theme.device.tablet} {
    font-size: 3.8rem;
    line-height: 4.8rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    font-size: 3rem;
    line-height: 4.4rem;
  }
`

export const H3 = styled(BaseHeading).attrs<typeof BaseHeading>(({ as }) => ({ as: as || 'h3' }))`
  font-size: 3.2rem;
  line-height: 4.4rem;
  font-weight: ${({ theme }) => theme.global.font.weight.normal};
  letter-spacing: 0;

  @media ${({ theme }) => theme.device.tablet} {
    font-size: 3.2rem;
    line-height: 4.4rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    font-size: 2.6rem;
    line-height: 3.4rem;
  }
`

export const H4 = styled(BaseHeading).attrs<typeof BaseHeading>(({ as }) => ({ as: as || 'h4' }))`
  font-size: 2.8rem;
  line-height: 4.4rem;
  font-weight: 500;
  letter-spacing: 0;
  font-feature-settings: 'pnum' on, 'lnum' on;

  @media ${({ theme }) => theme.device.tablet} {
    font-size: 2.6rem;
    line-height: 4.2rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    font-size: 2.4rem;
    line-height: 4rem;
  }
`

export const H5 = styled(BaseHeading).attrs<typeof BaseHeading>(({ as }) => ({ as: as || 'h5' }))`
  font-size: 2.2rem;
  line-height: 3.2rem;
  font-weight: 500;
  font-feature-settings: 'pnum' on, 'lnum' on;

  @media ${({ theme }) => theme.device.tablet} {
    font-size: 2rem;
    line-height: 3.2rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    font-size: 2rem;
    line-height: 3.2rem;
  }
`
